import { render, staticRenderFns } from "./DialogButtons.vue?vue&type=template&id=1a656a76&scoped=true&"
import script from "./DialogButtons.vue?vue&type=script&lang=ts&"
export * from "./DialogButtons.vue?vue&type=script&lang=ts&"
import style0 from "./DialogButtons.vue?vue&type=style&index=0&id=1a656a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a656a76",
  null
  
)

export default component.exports